
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blaze",
      function () {
        return require("private-next-pages/blaze/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blaze"])
      });
    }
  